import {AxiosResponse} from 'axios';
import {RightToErasureRequest} from '../backend/interfaces/right-to-erasure-request';
import {PostErasureRequest} from '../backend/requests/post-erasure-request';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class GdprErasureRequestsRepository {
  // Singleton Instance
  private static _instance: GdprErasureRequestsRepository;

  // Private
  private logger: Logger;

  static get instance(): GdprErasureRequestsRepository {
    if (!this._instance) {
      this._instance = new GdprErasureRequestsRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('GdprErasureRequestsRepository');
  }

  // Create a new "Right to Erasure" request for the user with the given email (System Administrator only)
  public async createErasureRequest(email: string): Promise<RightToErasureRequest> {
    const body: PostErasureRequest = {email};

    // Create the erasure request
    const response: AxiosResponse<RightToErasureRequest> =
      await BackendApiManager.instance.post<RightToErasureRequest>('/gdpr/erasure-requests', body);

    return response.data;
  }

  // List "Right to Erasure" requests, most recent first (System Administrator only)
  public async listErasureRequests(
    limit: number,
    skip: number
  ): Promise<{totalCount: number; data: Array<RightToErasureRequest>}> {
    // Set url
    const url: string = `/gdpr/erasure-requests?skip=${skip}&limit=${limit}`;

    // Get erasure requests from backend
    const response: AxiosResponse<Array<RightToErasureRequest>> =
      await BackendApiManager.instance.get<Array<RightToErasureRequest>>(url);

    // Return
    return {
      data: response.data,
      totalCount: parseInt(response.headers['x-total-count'] || '', 10),
    };
  }
}
